import { render, staticRenderFns } from "./CommandAssistantTraining.vue?vue&type=template&id=45a6116b&"
import script from "./CommandAssistantTraining.vue?vue&type=script&lang=js&"
export * from "./CommandAssistantTraining.vue?vue&type=script&lang=js&"
import style0 from "./CommandAssistantTraining.vue?vue&type=style&index=0&id=45a6116b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports